WiseMetering.Model.CircuitTag = WiseMetering.Model.extend({
    urlRoot: '/circuit_tags',

    sites: function() {
        const sites = _.collect(WiseMetering.circuits.where({ tag_id: this.id }), function(circuit) {
            return WiseMetering.zones.get(circuit.get('site_id'));
        });

        return new WiseMetering.Collection(_.uniq(sites));
    }
});
